import React from "react";
import { useEffect, useState } from "react";
import { Box, Grid2 } from "@mui/material";
import { useParams } from "react-router";
import WeekdayChart from "./graphs/WeekdayChart";
import { DateTime } from "luxon";
import HolidayChart from "./graphs/HolidayChart";
import ScatterPlot from "./graphs/ScatterPlot";
import MultiChartCard from "./graphs/MultiChartCard";
import DataGridCard from "./DataGridCard";
import TotalChart from "./graphs/FullTotalCard";
import Text from "../../genericComponents/Text";
import { CheckCircle, Warning } from "@mui/icons-material";

import MeterDetailsCards from "./graphs/MeterDetailsCards";
import { ElectricMeter, GasMeter } from "@mui/icons-material";

const MeterAnalysis = ({ setHeader }) => {

    const currentYear = DateTime.now().toObject().year;
    const [start, setStart] = useState(DateTime.utc(currentYear, 1, 1))
    const [end, setEnd] = useState(DateTime.utc(currentYear, 12, 31))
    const params = useParams();

    const icon = params.meterType === "ELECTRICITY" ? ElectricMeter : params.meterType === "GAS" ? GasMeter : null;
    useEffect(() => {
        setHeader({ icon: icon, text: `Meter` });
    }, [setHeader, icon])

    const id = params.id;
    const chartHeight = 390;
    const Icon = icon;
    const charts = [
        { name: (<Grid2 container spacing={1}>{<Icon />}<Text text={"i18n_chart_total"} /></Grid2>), graph: <TotalChart start={start} end={end} level={"METER"} meterType={params.meterType} id={id} height={chartHeight} /> },
        { name: (<Grid2 container spacing={1}>{<Icon />}<Text text={"i18n_chart_weekday"} /></Grid2>), graph: <WeekdayChart start={start} end={end} level={"METER"} meterType={params.meterType} id={id} height={chartHeight} /> },
        { name: (<Grid2 container spacing={1}>{<Icon />}<Text text={"i18n_chart_holiday"} /></Grid2>), graph: <HolidayChart start={start} end={end} level={"METER"} meterType={params.meterType} id={id} height={chartHeight} /> },
        { name: (<Grid2 container spacing={1}>{<Icon />}<Text text={"i18n_chart_temperature"} /></Grid2>), graph: <ScatterPlot start={start} end={end} level={"METER"} meterType={params.meterType} id={id} height={chartHeight} /> },
    ]
    return (
        <Box sx={{ flexGrow: 1 }}>
            <Grid2 container spacing={2}>
                <MeterDetailsCards name={params.name} icon={icon} height={chartHeight} meterType={params.meterType} start={start} end={end} level={"ORGANIZATION"} id={id} />
                <Grid2 size={{ xs: 12 }}>
                    <MultiChartCard start={start} setStart={setStart} setEnd={setEnd} end={end} title="i18n_analysis" graphs={charts} height={chartHeight} />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6 }}>
                    <DataGridCard pageSize={5} icon={Warning} title={"i18n_alerts"} type="alerts" />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6 }}>
                    <DataGridCard pageSize={5} icon={CheckCircle} title={"i18n_fixes"} type="fixes" />
                </Grid2>
            </Grid2>
        </Box>)
}
export default MeterAnalysis